import { render, staticRenderFns } from "./demographic-forms.vue?vue&type=template&id=6b5cc9d3&"
import script from "./demographic-forms.vue?vue&type=script&lang=ts&"
export * from "./demographic-forms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports